<template>
  <div>
    <div class="card">
      <div class="card-content">
        <div class="item-title c44">门店排名</div>
        <div>
          <div v-if="cardType === 'finance'" class="item-select c44">
            <span>营业收入</span>
            <span>结算金额</span>
          </div>
          <div v-if="cardType === 'manage'" class="item-select c44">
            <span>营业收入</span>
            <span>净销售额</span>
          </div>
        </div>
        <div class="item-block">
          <ul v-if="data">
            <li
              v-for="item in listData"
              :key="item.store"
              @click="handelQueryStaff(item.store_num,item.store_name)"
            >
              <div>
                <p class="c44">{{ item.store_name }}</p>
                <p v-if="cardType === 'finance'">{{ item.revenue }}</p>
                <p v-if="cardType === 'manage'">{{ item.revenue }}</p>
              </div>
              <div v-if="cardType === 'manage'">{{ item.net_sales }}</div>
              <div v-if="cardType === 'finance'">{{ item.arrive_amount }}</div>
            </li>
          </ul>
          <ul v-if="!data">
            <li>
              <span :style="{'font-size':'13px',color:'#444'}">暂无交易记录</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setStore } from '@/libs/auth.js'
export default {
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    cardType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    data() {
      let b = false
      if (this.listData && this.listData.length > 0) {
        b = true
      } else {
        b = false
      }
      return b
    }
  },
  methods: {
    handelQueryStaff(v, store) {
      this.$store.state.store = store
      setStore(store)
      this.$router.push({ name: 'clerk', query: { store_num: v }})
    },
    handleTips() {
      $.modal({
        title: '',
        text: '营业收入=净交易实收+净充值实收<br> 同时也等于 商家实收-退款总金额',
        buttons: [
          {
            text: '知道了'
          }
        ],
        extraClass: 'bg-tips'
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/index.less";
.card {
  border-radius: 5px;
}
.tips {
  position: relative;
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  color: #171b63;
  border: 1px solid #171b63;
  top:.2rem;
  right: .2rem;
  cursor: pointer;
  &::after {
    position: absolute;
    left: .22rem;
    top: -13px;
    clear: both;
    content: "?";
    font-style: normal;
    font-size: 0.8rem;
  }
}

</style>
